import React from "react";
import PageFrame from "./PageFrame";
import {AgentLine, firstWord, restOfName} from "./OfferingSummary";

/**
 * Page 02 of the Multi-Family deck - Offering Summary + map on the left, Income & Expenses on
 * the right, as on the multi-tenant page 02, with the rows an apartment deal is judged on.
 *
 * The header and the foot are the multi-tenant page's unchanged: the address on the eyebrow's
 * line so the property name has the full width, and the STRIVE mark, both agents and the page
 * number on one line at y=786. What differs is the two cards:
 *
 *   left   eight rows rather than six - Price Per Unit, Number of Units and Lot Size added
 *   right  ANNUAL and PER UNIT columns in place of CURRENT and PSF, and the operating
 *          expenses broken out into the lines an apartment P&L carries
 *
 * The data comes from bov-data-multifamily, which reads the Multi-Family underwriting's
 * Marketing figures.
 */
export default function OfferingSummaryMultiFamily(props) {
    const {property, subProduct, offeringSummary, incomeAndExpenses, agents, mapImageUrl, pageNo, totalPages} = props;

    const headerRight = [property.address, property.city, property.state, property.zip]
        .filter(Boolean)
        .join(', ');

    return (
        <PageFrame
            eyebrow={`OFFERING SUMMARY  •  ${subProduct}`}
            title={firstWord(property.name)}
            titleAccent={restOfName(property.name)}
            headerRight={headerRight}
            pageNo={pageNo}
            totalPages={totalPages}
        >
            <div className='bov-two-col bov-two-col--mf'>
                <div className='bov-two-col__left'>
                    <div className='bov-card bov-card--summary bov-card--mfSummary'>
                        <div className='bov-card__title'>{offeringSummary.name}</div>
                        {offeringSummary.rows.map(row => (
                            <div key={row.label} className='bov-kv'>
                                <div className='bov-kv__label'>{row.label}</div>
                                <div className='bov-kv__value'>{row.value}</div>
                            </div>
                        ))}
                    </div>

                    <div className='bov-map bov-map--mf'>
                        {mapImageUrl ? <img className='bov-map__img' src={mapImageUrl} alt=''/> : null}
                    </div>

                    <AgentLine agents={agents} index={0}/>
                </div>

                <div className='bov-two-col__right'>
                    <div className='bov-card bov-card--ie bov-card--mfIe'>
                        <div className='bov-mfie'>
                            <div className='bov-mfie__row bov-mfie__row--head'>
                                <div className='bov-mfie__label'>{incomeAndExpenses.header[0]}</div>
                                <div className='bov-mfie__num'>{incomeAndExpenses.header[1]}</div>
                                <div className='bov-mfie__num'>{incomeAndExpenses.header[2]}</div>
                            </div>

                            {incomeAndExpenses.rows.map((row, i) => (
                                <div
                                    key={`${row.label}-${i}`}
                                    className={[
                                        'bov-mfie__row',
                                        row.strong || row.heading ? 'bov-mfie__row--strong' : '',
                                    ].filter(Boolean).join(' ')}
                                >
                                    <div className='bov-mfie__label'>{row.label}</div>
                                    <div className='bov-mfie__num'>{row.heading ? '' : row.annual}</div>
                                    <div className='bov-mfie__num'>{row.heading ? '' : row.perUnit}</div>
                                </div>
                            ))}

                            <div className='bov-mfie__row bov-mfie__row--total'>
                                <div className='bov-mfie__label'>{incomeAndExpenses.footer.label}</div>
                                <div className='bov-mfie__num'>{incomeAndExpenses.footer.annual}</div>
                                <div className='bov-mfie__num'>{incomeAndExpenses.footer.perUnit}</div>
                            </div>
                        </div>
                    </div>

                    <AgentLine agents={agents} index={1}/>
                </div>
            </div>
        </PageFrame>
    );
}
